import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/otrosEquipos/EquipoRiegoDrenaje/RiegoDrenaje1.png';
import Img2 from '../../img/products/otrosEquipos/EquipoRiegoDrenaje/RiegoDrenaje2.png';

const EquipoRiegoDrenaje = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Equipos para Riego y Drenaje </h2>
      <div className="row align-items-start mb-5">
        {/* Columna izquierda: imágenes en cuadrícula */}
        <div className="col-md-5">
          <div className="row g-2">
            <div className="col-6">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Riego-Drenaje 1" />
            </div>
            <div className="col-6">
              <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Riego-Drenaje 2" />
            </div>
          </div>
        </div>

        {/* Columna derecha: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            El equipo de bombeo para riego y drenaje está diseñado para proporcionar un suministro eficiente y confiable 
            de agua en sistemas de riego agrícola y para la evacuación de agua en aplicaciones de drenaje.
          </p>
          <p className="lead text-justify">
            Estos equipos son esenciales para mantener la salud de los cultivos y la gestión de aguas en terrenos agrícolas, 
            así como para evitar inundaciones en áreas vulnerables. Utiliza bombas de alta capacidad para asegurar un 
            suministro continuo de aguapara riego y una evacuación eficiente del agua de drenaje.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EquipoRiegoDrenaje;
